import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { useAppSelector, useRetailerUrl } from 'src/utils/Hooks';
import { getProductImageUrl } from 'src/utils/image';
import { Link } from 'react-router-dom';
import { ProductImage } from 'src/components/BeaconV2Components/ProductCard';
import {
  BEACON_PRO_SIDEBAR_IMAGE_MAX_HEIGHT,
  BEACON_PRO_SIDEBAR_IMAGE_WIDTH
} from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { SlFlippableCard } from 'src/components/BeaconV2Components/SlFlippableCard';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';

/**
 * Product card that appears in top left corner when on the product view
 */
export default function EntityProductCard() {
  const mainEntity = useAppSelector((state) => state.entityService.mainEntity);
  const { searchParams, additionalParams } = useAppSelector((state) => state.app.queryParams);
  const retailerUrl = useRetailerUrl(mainEntity.stacklineSku);

  const cardFront = (
    <Flex flexDirection="column" alignItems="center">
      <ProductImage
        imageUri={getProductImageUrl(mainEntity.stacklineSku)}
        mainDisplayTitle={mainEntity.name}
        secondaryDisplayTitle={mainEntity.shortDisplayName}
        width={BEACON_PRO_SIDEBAR_IMAGE_WIDTH}
        height={BEACON_PRO_SIDEBAR_IMAGE_MAX_HEIGHT}
        fallbackImageStyle={{ marginBottom: 0 }}
      />
      <Flex marginTop="8px" gap="sm">
        <Link target="_blank" rel="noreferrer" to={`/brand/${mainEntity.brandId}${searchParams}${additionalParams}`}>
          <Text variant="subtitle2">{mainEntity.brandName}</Text>
        </Link>
      </Flex>
      <div style={{ marginTop: '12px' }}>
        <Link to={`/product/${mainEntity.stacklineSku}${searchParams}${additionalParams}`}>
          <Text variant="body3" textAlign="center" truncateLines={2} title={mainEntity.name}>
            {mainEntity.name}
          </Text>
        </Link>
      </div>
    </Flex>
  );

  const cardBackItems = [
    {
      title: 'Product ID',
      value: mainEntity.stacklineSku,
      link: `/product/${mainEntity.stacklineSku}${searchParams}${additionalParams}`
    },
    {
      title: 'Retailer Sku',
      value: mainEntity.retailerSku,
      link: retailerUrl,
      newTab: true
    },
    {
      title: 'Category',
      value: mainEntity.categoryName,
      link: `/category/${mainEntity.categoryId}${searchParams}${additionalParams}`
    },
    {
      title: 'Subcategory',
      value: mainEntity.subCategoryName,
      link: `/subcategory/${mainEntity.subCategoryId}${searchParams}${additionalParams}`
    }
  ];

  const cardBack = (
    <Flex flexDirection="column" gap="sm" width="124px" paddingLeft="16px">
      {cardBackItems.map(({ title, value, link, newTab }) => (
        <Flex flexDirection="column" gap="xxs" key={title}>
          <Text transform="uppercase" variant="subtitle4">
            {title}
          </Text>
          {newTab ? (
            <a href={link} target="_blank" rel="noreferrer">
              <Text variant="body3">{value}</Text>
            </a>
          ) : (
            <Link to={link}>
              <Text variant="body3">{value}</Text>
            </Link>
          )}
        </Flex>
      ))}
    </Flex>
  );

  return (
    <SlFlippableCard
      sx={{
        height: '160px',
        border: 'none'
      }}
      flipIconSize="16px"
      cardFront={() => cardFront}
      cardBack={() => cardBack}
      flipContainerSx={{
        top: '0px'
      }}
    />
  );
}
